// Vulcan Design System Light Theme
// This file provides Vulcan-compatible theme tokens for use throughout the application

import {
  paletteTokens,
  typographyTokens,
  spacingTokens,
  scaleTokens,
  borderTokens,
  elevationTokens,
  iconTokens,
  breakpointTokens,
} from './tokens'
import { componentTokens } from './theme'

// Vulcan Light Theme - Compatible with @alchemytelcosolutions/vulcan
export const lightTheme = {
  palette: paletteTokens,
  typography: typographyTokens,
  spacing: spacingTokens,
  scale: scaleTokens,
  border: borderTokens,
  elevation: elevationTokens,
  icon: iconTokens,
  breakpoint: breakpointTokens,
  component: componentTokens,
} as const

// Type definitions for Vulcan theme
export type VulcanLightTheme = typeof lightTheme
export type Theme = VulcanLightTheme

// Export for compatibility
export { lightTheme as vulcanLightTheme }
export default lightTheme